let version = '1.5.8'
module.exports =  {
    version

}
